<template>
  <div class="platform-sku-list">
    <a @click="jumpDetails" class="jump-details" href="javascript:;">
      <div class="sku-imgs">
        <div class="sku-imgs-wrapper auto-x">
          <img
            :key="index"
            class="van-hairline--surround"
            v-for="(skuImg, index) in sku"
            v-lazy="skuImg"
          />
        </div>
      </div>

      <span class="tips">
        共{{total}}件
        <img src="../assets/img/public/double-arrow.png" />
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'orderSkuList',
  props: {
    sku: {
      type: Array,
      require: true
    },
    id: {
      type: String,
      require: true
    },
    total: {
      type: [Number, String]
    }
  },
  methods: {
    jumpDetails () {
      this.$router.push({ name: 'orderDetails', query: { orderid: this.id } })
    }
  }
}
</script>

<style lang="less" scoped>
.platform-sku-list {
  height: 1.8rem;
  .flex-center;
  .jump-details {
    position: relative;
    padding: 0 0.2rem;
    height: 100%;
    background-color: #f2f2f2;
    .flex-between;
    .sku-imgs {
      display: flex;
      width: 5.6rem;
      overflow: hidden;
      .sku-imgs-wrapper {
        white-space: nowrap;
      }
      img {
        width: 1.4rem;
        height: 1.4rem;
        object-fit: contain;
        margin-right: 0.24rem;
        background-color: #fff;
        &:last-child {
          margin-right: 0;
        }
      }
    }

    .tips {
      font-size: @fz24;
      color: @base;
      padding-left: 0.2rem;
      white-space: nowrap;
      .flex-center;
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
    }
  }
}
</style>
